import { Store } from "@tanstack/react-store";

type InquiryStep = "list" | "contactForm" | "schedule" | "details" | "success";
type InquiryMode = "direct" | "watchlist";

type Appointment = {
  start: Date;
  end: Date;
};

interface InquiryFormData {
  userId?: string;
  // Contact form
  salutation?: "Frau" | "Herr" | "Divers";
  firstName?: string;
  lastName?: string;
  company?: string;
  email?: string;
  telephone?: string;
  // Schedule
  appointments?: Appointment[];
  // Details
  eventTypeId?: number;
  businessType?: "Privat" | "Geschäftlich";
  numberOfRooms?: number;
  numberOfGuests?: number;
  budgetType?: "Gesamt" | "Pro Person";
  budget?: number;
  budgetCurrency?: string;
  notes?: string;
  requestedRooms?: Array<{ id: number; name: string }>;
}

interface InquiryState {
  isOpen: boolean;
  inquiryCurrentStep: InquiryStep;
  inquiryMode: InquiryMode;
  selectedLocationIds: number[];
  formData: InquiryFormData;
}

export const InquiryStore = new Store<InquiryState>({
  isOpen: false,
  inquiryCurrentStep: "list",
  inquiryMode: "direct",
  selectedLocationIds: [],
  formData: {},
});

export const openInquiry = (
  mode: InquiryMode = "direct",
  locationIds: number[] = [],
) => {
  InquiryStore.setState((prevState) => ({
    ...prevState,
    isOpen: true,
    inquiryMode: mode,
    selectedLocationIds: locationIds,
    inquiryCurrentStep: mode === "direct" ? "contactForm" : "list",
  }));
};

export const closeInquiry = () => {
  InquiryStore.setState((prevState) => ({
    ...prevState,
    isOpen: false,
    selectedLocationIds: [],
    formData: {},
  }));
};

export const setInquiryCurrentStep = (step: InquiryStep) => {
  InquiryStore.setState((prevState) => ({
    ...prevState,
    inquiryCurrentStep: step,
  }));
};

export const setInquiryFormData = (data: Partial<InquiryFormData>) => {
  InquiryStore.setState((prevState) => ({
    ...prevState,
    formData: { ...prevState.formData, ...data },
  }));
};

export const resetInquiryFormData = () => {
  InquiryStore.setState((prevState) => ({
    ...prevState,
    formData: {},
    selectedLocationIds: [],
  }));
};

export const setInquirySelectedLocations = (locationIds: number[]) => {
  InquiryStore.setState((prevState) => ({
    ...prevState,
    selectedLocationIds: locationIds,
  }));
};
